// src/utils/statusHelpers.ts

const ACTIVE_RAPIM_STATUSES = ['dijadwalkan', 'berlangsung'];

export function getActiveRapimSchedule(rapat_pimpinan?: any[] | null): any | null {
  if (!Array.isArray(rapat_pimpinan) || rapat_pimpinan.length === 0) {
    return null;
  }

  return rapat_pimpinan.find((rapat) =>
    ACTIVE_RAPIM_STATUSES.includes(String(rapat?.status || '').toLowerCase())
  ) || null;
}

export function getStatusExplanation(
  status: string,
  context?: {
    pernahDitolak?: boolean;
    isMenungguRapimUlang?: boolean;
    warekTujuan?: { display_name?: string } | null;
    validasiL1Skipped?: boolean;
    rapat_pimpinan?: any[];
  }
): string {
  const { pernahDitolak, isMenungguRapimUlang, warekTujuan, validasiL1Skipped, rapat_pimpinan } = context || {};
  const activeRapim = getActiveRapimSchedule(rapat_pimpinan);

  switch (status?.toLowerCase()) {
    case 'draf':
      return pernahDitolak
        ? 'Laporan telah dikembalikan dan perlu diperbaiki sebelum diajukan ulang.'
        : 'Laporan masih dalam tahap penyusunan dan belum diajukan untuk persetujuan.';

    case 'diajukan':
      if (validasiL1Skipped) {
        return `Laporan diajukan langsung ke ${warekTujuan?.display_name || 'Wakil Rektor'} untuk persetujuan karena pelapor adalah Kepala Bagian.`;
      }
      return 'Laporan telah diajukan dan sedang menunggu peninjauan oleh Dekan atau Kepala Lembaga terkait.';

    case 'validasi_l1':
      const warekName = warekTujuan?.display_name || 'Wakil Rektor';
      return `Dekan/Ketua Lembaga telah menyetujui laporan ini. Sekarang menunggu persetujuan dari ${warekName} selaku pimpinan bidang terkait.`;

    case 'validasi_l2':
      return 'Wakil Rektor telah menyetujui laporan ini. Laporan siap untuk diagendakan dalam Rapat Pimpinan untuk penetapan keputusan tindak lanjut.';

    case 'ditolak_l1':
      return 'Laporan dikembalikan oleh Dekan/Ketua Lembaga. Silakan periksa catatan yang diberikan dan lakukan perbaikan yang diperlukan, kemudian ajukan ulang.';

    case 'ditolak_l2':
      return 'Laporan dikembalikan oleh Wakil Rektor. Silakan periksa catatan yang diberikan dan lakukan perbaikan yang diperlukan.';

    case 'antrean_rapim':
      if (isMenungguRapimUlang && !activeRapim) {
        return 'Laporan menunggu jadwal Rapat Pimpinan ulang karena tindak lanjut sebelumnya mengalami hambatan yang perlu dibahas kembali.';
      }
      if (activeRapim) {
        return `Laporan telah dijadwalkan pada Rapat Pimpinan "${activeRapim.judul}" dan menunggu penetapan keputusan tindak lanjut.`;
      }
      return 'Laporan sudah masuk antrean dan menunggu dijadwalkan dalam Rapat Pimpinan terdekat untuk penetapan keputusan tindak lanjut.';

    case 'diputuskan':
      return 'Keputusan tindak lanjut (Tindak Lanjut) telah ditetapkan dalam Rapat Pimpinan. Penanggung jawab (PIC) akan segera memulai pelaksanaan.';

    case 'berlangsung':
      return 'Tindak lanjut sedang dalam proses pengerjaan oleh penanggung jawab (PIC) yang telah ditunjuk dalam Rapat Pimpinan.';

    case 'selesai':
      return 'Semua tindak lanjut telah diselesaikan dan dikonfirmasi oleh pimpinan. Laporan dinyatakan tuntas.';

    case 'diarsipkan':
      return 'Laporan telah dipindahkan ke arsip. Data tetap tersimpan untuk keperluan audit dan pelaporan.';

    case 'diselesaikan_lokal':
      return 'Masalah telah ditangani langsung oleh pimpinan terkait (Dekan/Wakil Rektor) tanpa perlu pembahasan di Rapat Pimpinan. Pimpinan yang lebih tinggi telah menerima pemberitahuan.';

    default:
      return 'Status tidak dikenali.';
  }
}

export function getNextActor(
  status: string,
  warekTujuan?: { display_name?: string } | null,
  rapat_pimpinan?: any[],
  isMenungguRapimUlang?: boolean
): string {
  const activeRapim = getActiveRapimSchedule(rapat_pimpinan);

  switch (status?.toLowerCase()) {
    case 'diajukan':
      return 'Dekan / Kepala Lembaga';
    case 'validasi_l1':
      return warekTujuan?.display_name || 'Wakil Rektor Bidang';
    case 'validasi_l2':
    case 'antrean_rapim':
      if (isMenungguRapimUlang && !activeRapim) {
        return 'Sekretaris / Admin (Penjadwalan Ulang Rapat)';
      }
      if (activeRapim) {
        return 'Pembahasan pada Rapat Pimpinan (Terjadwal)';
      }
      return 'Sekretaris / Admin (Penjadwalan Rapat)';
    case 'diputuskan':
    case 'berlangsung':
      return 'Penanggung Jawab (PIC)';
    default:
      return '-';
  }
}
